import { api } from '../../../../helper/api';
import { mConstants } from '../../../../helper/constants';
import { FileResponse } from '../../customer/entity/customer.model';

function uploadFile(file: File, isPublic = false): Promise<FileResponse> {
  const formData = new FormData();
  formData.append('file', file);

  return api.post(
    `${mConstants.ORDER_URL}/file/upload${isPublic ? '/public' : ''}`,
    formData
  );
}

export const fileService = {
  uploadFile,
};
